export default __webpack_public_path__ + "be1350fe80d492e95279aea9e6a4ef96.png";